package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Unified creator response for authors, podcasters, and readers (Feature 014)
 * Provides consistent structure across all creator types with multilingual support
 *
 * Frontend copy with String-based UUIDs (Kotlin/JS compatible)
 */
@Serializable
data class CreatorResponse(
    val id: String,                             // UUID as string
    val name: String,
    val biography: String? = null,
    val type: CreatorType,
    val profileImageUrl: String? = null
)

/**
 * Creator type discriminator
 */
@Serializable
enum class CreatorType {
    AUTHOR,
    PODCASTER,
    READER
}
